(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('mailBodyConverterMT', ["$q", function ($q) {
        return function (input) {
            if (input.data && input.data.data) {
                return $q.when({
                    data: _(input.data.data).map(function (value, key) {
                        return {
                            key: key,
                            value: _(value).isString() ? value.split('\r') : ['' + value]
                        };
                    })
                });
            }
            return $q.reject({ status: 404 });
        };
    }]);
}());